import { render, staticRenderFns } from "./ProductSearchBrowse.vue?vue&type=template&id=14cd66b4"
import script from "./ProductSearchBrowse.vue?vue&type=script&lang=ts"
export * from "./ProductSearchBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14cd66b4')) {
      api.createRecord('14cd66b4', component.options)
    } else {
      api.reload('14cd66b4', component.options)
    }
    module.hot.accept("./ProductSearchBrowse.vue?vue&type=template&id=14cd66b4", function () {
      api.rerender('14cd66b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductSearchBrowse.vue"
export default component.exports